<script setup lang="ts">
import { TabsContent, type TabsContentProps } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps<TabsContentProps & { class?: string }>()
</script>

<template>
	<TabsContent
		:class="
			cn(
				'ring-offset-background focus-visible:ring-ring bg-wg-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-offset-4',
				props.class,
			)
		"
		v-bind="props"
	>
		<slot />
	</TabsContent>
</template>
